// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"Vss1O","rc-tabs-bar":"qVeax","rc-tabs-tab":"ikh-3","rc-tabs-tab-active":"fEEFO","terms":"R5kTX","orderHistory-navigation":"a865L","footerButton":"_1-cPw"};